import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

const copy = {
  nl: {
    title: "Betaling geannuleerd",
    sub: "Je bestelling is niet afgerond. Je winkelmand is bewaard.",
    home: "Terug naar home",
    shop: "Verder winkelen",
  },
  en: {
    title: "Payment cancelled",
    sub: "Your order was not completed. Your cart has been saved.",
    home: "Back to home",
    shop: "Continue shopping",
  },
};

const PaymentCancel = () => {
  const { lang, setCartOpen } = useApp();
  const c = copy[lang];
  return (
    <main className="min-h-[70vh] flex items-center justify-center px-5 py-24">
      <div className="max-w-md w-full text-center bg-white rounded-3xl border border-[#EEDDD3] p-10 shadow-[0_30px_70px_-30px_rgba(160,100,80,0.35)]">
        <XCircle className="h-14 w-14 mx-auto text-[#C8604B]" />
        <h1 className="mt-6 font-serif text-4xl text-[#3A2C28]">{c.title}</h1>
        <p className="mt-4 text-[15px] text-[#6E5A52] leading-relaxed">{c.sub}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="h-11 px-6 rounded-full bg-[#3A2C28] text-white text-[12px] tracking-label uppercase hover:bg-[#B4715C] flex items-center">
            {c.home}
          </Link>
          <button onClick={() => setCartOpen(true)} className="h-11 px-6 rounded-full border border-[#D6B7A9] text-[#5A4740] text-[12px] tracking-label uppercase hover:border-[#B4715C] hover:text-[#B4715C]">
            {c.shop}
          </button>
        </div>
      </div>
    </main>
  );
};

export default PaymentCancel;
